import { AuthService, CheckOutService } from "../../../shared/services";
import {
  CustomLabel,
  FlexContainer,
  ModalComponent,
  RedButton,
  ToastService,
} from "@mindmemobile/mm-shared-global";
import React from "react";

type Props = {
  onClose: (deleted: boolean) => void;
  id: string;
};
const DeleteCheckoutPopup: React.FC<Props> = ({ onClose, id }) => {
  const [isAPIRequestPending, setAPIRequestPending] = React.useState(false);

  function body() {
    return (
      <FlexContainer fxLayout="column" justifyContent="center" alignItems="center" spacing={10}>
        <CustomLabel>
          Do you want to{" "}
          <CustomLabel color="#FF0000" fontWeight={600}>
            permanently delete
          </CustomLabel>{" "}
          this Checkout?
        </CustomLabel>
      </FlexContainer>
    );
  }

  function onDelete() {
    if (isAPIRequestPending) return;

    setAPIRequestPending(true);
    CheckOutService.deleteCheckout(
      AuthService.authData.accountId,
      id
    ).subscribe({
      next: (response) => {
        setAPIRequestPending(false);
        if (response.result.success) {
          ToastService.showSuccess("Checkout Deleted Successfully");
          onClose(true);
        }
      },
      error: () => {
        setAPIRequestPending(false);
        ToastService.showError("Error in deleting checkout");
      },
    });
  }

  return (
    <ModalComponent
      title="Delete Checkout"
      titleFontSize="22px"
      bodyPadding="50px 61px"
      showFooter={true}
      minHeight="130px"
      wrapperWidth="550px"
      bodyBackgroundColor="#fff"
      footerBackground="rgba(255, 0, 0, 0.1)"
      footerHeight="auto"
      redHeader={true}
      blueHeader={false}
      onClose={() => onClose(false)}
      footerContent={
        <FlexContainer alignItems="center" justifyContent="center" spacing={15}>
          <RedButton
            disabled={isAPIRequestPending}
            minWidth="120px"
            height="40px"
            onClick={() => onDelete()}
          >
            Delete
          </RedButton>
          <RedButton
            primary
            minWidth="120px"
            height="40px"
            onClick={() => onClose(false)}
          >
            Do Not Delete
          </RedButton>
        </FlexContainer>
      }
    >
      {body()}
    </ModalComponent>
  );
};

export default DeleteCheckoutPopup;
